import { getProject, loadProject } from 'owa-timestream-store';
import { logUsage } from 'owa-analytics';
import { trace } from 'owa-trace';
import getTimeStreamSubscription from './AssetSubscriptions';
import handleAssetRowNotification from './handleAssetRowNotification';
import type RowNotificationPayload from 'owa-service/lib/contract/RowNotificationPayload';

export default function handleAssetNotification(e: RowNotificationPayload) {
    const subscriptionInfo = e.id && getTimeStreamSubscription(e.id);
    if (subscriptionInfo) {
        logUsage('OUTLOOKSPACES_ASSET_NOTIFICATION', [e.EventType]);

        const { projectId } = subscriptionInfo;
        const { canSync } = getProject(projectId);
        if (canSync) {
            // Delta sync works best if we do it on every notification
            trace.info(`ASSET NOTIFICATION -> DELTA SYNC: ${e.EventType} ${projectId}`);
            loadProject(projectId);
        } else {
            switch (e.EventType) {
                case 'RowAdded':
                case 'RowModified':
                    const itemId = e.Item!.ItemId!.Id!;
                    const lastModified = e.Item?.LastModifiedTime!;
                    trace.info(`ASSET NOTIFICATION: ${e.EventType} ${projectId} ${itemId}`);
                    handleAssetRowNotification(e.EventType, projectId, itemId, lastModified);
                    break;
                case 'RowDeleted':
                // Item in RowDeleted payload only has InstanceKey. We don't have it in the TimeStreamAsset
                // (or the SDS item, afaik), so we can't pinpoint which asset got deleted, so we need to reload.
                case 'Reload':
                    trace.info(`ASSET NOTIFICATION: ${e.EventType} ${projectId}`);
                    loadProject(projectId);
                    break;
            }
        }
    }
}
